import {  UITimeFormat } from 'src/lib/constants'
import dayjs from 'dayjs';

export function displayTripTime(data: { startTime: string | null; endTime: string | null }) {
  return `${data.startTime ? dayjs.utc(data.startTime).format(UITimeFormat) : ''}${data.endTime ? ` - ${dayjs.utc(data.endTime).format(UITimeFormat)}` : ''}`
}
